import {override} from 'mobx';
import {AutoAnimation} from "../../../../../infrastructure/models/animation/auto-animation";
import {MatchStartedAnimationSetModel} from "../../../../../infrastructure/models/animation/game/animation-set-models/goal/match-started-animation-set-model";
import {ANIMATION_TIMES} from "../../../../../core/consts";

export class GameCenterHeaderMatchStartedAnimationSetModel extends MatchStartedAnimationSetModel {
  duration: Number;

  constructor(animation) {
    super(animation);

    this.duration = ANIMATION_TIMES.GAME_CENTER.matchStartedAnimationTime;
  }

  @override get statusText(): AutoAnimation {
    const enterAnimation: String = 'hide';
    const mainAnimation: String = 'scale-up-center-infinite';
    const leaveAnimation: String = '';

    const statusText = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      this.durationByRatio(0.6),this.durationByRatio(0.4) ,0);

    return statusText;
  }

  @override get gameTime(): AutoAnimation {
    const enterAnimation: String = 'fade-in-and-out';
    const mainAnimation: String = 'fade-in-and-out';
    const leaveAnimation: String = 'fade-in-and-out';

    const gameTime = new AutoAnimation(enterAnimation, mainAnimation, leaveAnimation, '',
      0, this.durationByRatio(0.35), 0, 0);

    return gameTime;
  }
}
